export default {
  data: () => ({
    locale: 'en', // i18n语言信息：当前语言环境
    localeList: [] // i18n语言信息：所有语言环境
  }),
  methods: {
    updateI18n(locale) {
      this.$store.commit('setLang', locale)
      this.$store.commit('setLangText', locale)
      this.$SetCookieFn('kili-language', locale)
      const routeNameArr = ['seller-center-after-sale-id'] // 切换语言,当前所在页面需要刷新的路由name集合 后端做了国际化,需要刷新页面重新请求
      if (routeNameArr.includes(this.$route.name) && this.locale !== locale) {
        // this.$router.go(0)
        this.$tabs.refresh()
      }
      this.locale = locale
      this.$i18n.locale = locale
    },
    initI18n() {
      this.localeList = this.$store.state.locales || []
      const locale = localStorage.getItem('locale') || 'en'

      this.locale = locale
      if (this.$store.state.locale !== locale) {
        this.$store.commit('setLang', locale)
        this.$SetCookieFn('kili-language', locale)
      }
      this.$store.commit('setLangText', locale)
      this.$i18n.locale = locale
    }
  }
}
